// Display-label helpers shared by the visualization data prep and the editor.
//
// Binning a numeric field and aggregating its distribution turns the bin
// labels (e.g. "Small") into verbose column keys such as
// "distribution__area_bin__Small". These helpers resolve what a chart, donut
// or table should *show* for such a key: a user override from a `labels` map,
// else a fallback (the field schema label), else the raw key. The underlying
// data and column keys are never changed.

// Effective label for `key`. A non-empty entry in `labels` wins; otherwise the
// `fallback` when present, then the raw key.
export function displayLabel(labels, key, fallback) {
  const custom = labels && labels[key];
  if (custom !== undefined && custom !== null && String(custom).trim() !== '') {
    return String(custom);
  }
  return fallback != null ? fallback : key;
}

// Schema label of a field key (the readable name the pipeline assigned), or
// null when the field is not in the schema.
export function schemaLabel(fields, key) {
  const field = (fields || []).find((f) => f.key === key);
  return field ? field.label : null;
}
